import { Box, SxProps, Theme, useTheme } from "@mui/material";

type Props = {
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
};

export function TextBox({ sx, children }: Props) {
  return (
    <Box
      sx={[
        {
          bgcolor: "background.paper",
          borderRadius: (theme) => theme.shape.borderRadius,
          maxWidth: "1200px",
          p: 2,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}

export function TextBoxRaw({ children }: { children?: React.ReactNode }) {
  const theme = useTheme();
  return (
    <Box
      sx={[
        {
          bgcolor: "background.paper",
          borderRadius: (theme) => theme.shape.borderRadius,
          color: theme.palette.text.secondary,
          maxWidth: "1200px",
          p: 2,
        },
      ]}
    >
      <pre
        style={{
          whiteSpace: "pre-wrap",
          margin: 0,
        }}
      >
        {children}
      </pre>
    </Box>
  );
}
